export default "__VITE_ASSET__53ecebe9__"